import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

// Components
import ScheduleTourButton from 'src/Components/homeSearch/ListingDetails/ScheduleTour/ScheduleTourButton'
import { Button, ActionBar, Text } from 'src/Components'

import useViewport from 'src/hooks/useViewport'

// Utils
import history from 'src/history'

// Components
import {
  IconHeart,
  IconHeartEmpty,
  IconAngleLeft,
} from 'src/Components/shared/Icon'

import {
  useFavoriteListingClickHandler,
  useIsFavoritedListing,
} from 'src/hooks/listings'

const ListingActionBar = ({
  listing,
  showTourButton,
  headingComponent: Heading = null,
  backText = 'Back',
  ...restProps
}) => {
  const { isLargeOrAbove } = useViewport()
  const handleFavoriteClick = useFavoriteListingClickHandler()
  const isFavorite = useIsFavoritedListing(listing)

  const backButtonText = isLargeOrAbove ? (
    backText
  ) : (
    <FormattedMessage
      id='HomeSearch.listings.actions.back'
      defaultMessage='Back'
    />
  )

  return (
    <ActionBar {...restProps}>
      <ActionBar.Left>
        {history.length > 1 && (
          <Button
            data-qa='buttonBack'
            aria-label='back'
            iconStart={IconAngleLeft}
            onClick={() => history.goBack()}
          >
            <Text element='span' weight='semibold'>
              {backButtonText}
            </Text>
          </Button>
        )}
      </ActionBar.Left>
      <ActionBar.Heading>
        {isLargeOrAbove && Heading && <Heading />}
      </ActionBar.Heading>
      <ActionBar.Right>
        {(isLargeOrAbove || showTourButton) && <ScheduleTourButton />}
        <Button
          iconStart={isFavorite ? IconHeart : IconHeartEmpty}
          onClick={e => handleFavoriteClick(e, listing)}
        >
          <Text element='span' weight='semibold'>
            <FormattedMessage
              id='HomeSearch.listings.actions.favorite'
              defaultMessage='Favorite'
            />
          </Text>
        </Button>
      </ActionBar.Right>
    </ActionBar>
  )
}

ListingActionBar.propTypes = {
  listing: PropTypes.object,
  headingComponent: PropTypes.any,
  backText: PropTypes.string,
  showTourButton: PropTypes.bool,
}

// showTourButton - TEMP FIX - we may need to create NEW overlay listings action bar
// to handle varying screen sizes in the overlay panel headers for photos and map

export default ListingActionBar
